import { useQuery } from '@tanstack/react-query';

import { HTTP_ERROR_STATUS_CODES, queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'api/hooks/useHTTPRequest';

export const useCoachQuery = (options = { enabled: true }) => {
  const { request } = useQueryHTTPRequest();
  const {
    data,
    status,
    isFetching,
    isInitialLoading: isLoading,
  } = useQuery(
    [queryKeys.coach],
    () => request({ url: '/api/users/me/coach' }),
    {
      enabled: options.enabled ?? true,
      placeholderData: {
        userEmail: '',
        userName: '',
        userPicture: { url: '' },
        chatId: '',
      },
      useErrorBoundary: (error: Error) =>
        error?.message !== HTTP_ERROR_STATUS_CODES.NOT_FOUND,
    }
  );

  return { coach: data, status, isFetching, isLoading };
};
